import React from "react"
import {Container} from "./components"

export const StandardBackgroundContainer = ({children}) => {
    return <Container data-testid="secondary-meganav-narrow">{children}</Container>
}

export default StandardBackgroundContainer
